import { inject, Injectable } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

import { IdealsDialogService } from '@ideals/services/dialog';

import { HelpModalComponent, HelpSection } from '../components/help-modal/help-modal.component';
import { HelpStore } from '../store/help.store';

@Injectable({ providedIn: 'root' })
export class HelpOpenerService {
  readonly #dialogService = inject(IdealsDialogService);
  readonly #helpStore = inject(HelpStore);
  readonly #translateService = inject(TranslateService);

  #dialogRef: MatDialogRef<HelpModalComponent> | null = null;

  openHelp(section: HelpSection): void {
    if (this.#dialogRef) {
      return;
    }

    this.#helpStore.loadHelpData({
      language: this.#translateService.currentLang,
    });

    this.#dialogRef = this.#dialogService.open(
      HelpModalComponent,
      {
        data: { section },
        panelClass: 'help-modal',
      },
    );

    this.#dialogRef.afterClosed().subscribe(() => {
      this.#dialogRef = null;
    });
  }
}
